import React, { useEffect, useMemo } from "react";
import { Spin, Tabs } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { getWidgetdata } from "../../redux/Widget/WidgetActions";
import * as widgetActionTypes from "../../redux/Widget/WidgetTypes";

import GetStarted from "../widget/GetStarted";
import Appearance from "../widget/Appearance";
import Faqs from "../faqs/faqs";
import BrandAIBot from "./BrandAIBot";

const BrandWidgetSettings = () => {
  const dispatch = useDispatch();
  const { brandId } = useParams();
  const widgetLoading = useSelector((state) => state.WidgetReducer.widgetLoading);

  useEffect(() => {
    if (!brandId) return;

    dispatch(getWidgetdata({ brand_token: brandId }));
    return () => {
      dispatch({ type: widgetActionTypes.WIDGET_GET_CLEAN });
    };
  }, [brandId]);

  const items = useMemo(
    () => [
      {
        key: "1",
        label: "Get Started",
        children: <GetStarted BrandToken={brandId} />,
      },
      {
        key: "2",
        label: "Appearance",
        children: widgetLoading ? (
          <div style={{ padding: 16 }}>
            <Spin />
          </div>
        ) : (
          <Appearance BrandToken={brandId} />
        ),
      },
      {
        key: "3",
        label: "FAQs",
        children: (
          <div style={{ padding: "8px 0 0 0", width: "100%", minWidth: 0 }}>
            <Faqs brandToken={brandId} />
          </div>
        ),
      },
      {
        key: "4",
        label: "AI Bot",
        children: (
          <div style={{ padding: "8px 0 0 0", width: "100%", minWidth: 0 }}>
            <BrandAIBot brandToken={brandId} />
          </div>
        ),
      },
    ],
    [brandId, widgetLoading]
  );

  return (
    <section className="brandWidgetSettings">
      <Tabs defaultActiveKey="1" items={items} />
    </section>
  );
};

export default BrandWidgetSettings;

